import { mainUrl } from './apiSettings';

export const JOURNEY_POST = `${mainUrl}/journey`;

//  GET - https://4majc3no2f.execute-api.sa-east-1.amazonaws.com/dev/journeys/{visibility}
export const JOURNEY_GET = (visibilityRange) =>  `${mainUrl}/journeys/${visibilityRange}`;
export const JOURNEY_PATCH = `${mainUrl}/journey`;
export const JOURNEY_GET_SPECIFIC = (uniqueId) => `${mainUrl}/journey/${uniqueId}`;
export const JOURNEY_GET_THUMBNAIL = (uniqueId) => `${mainUrl}/journey/thumbnail/${uniqueId}`

// PATCH - https://4majc3no2f.execute-api.sa-east-1.amazonaws.com/dev/journey/visibility
export const JOURNEY_VISIBILITY = `${mainUrl}/journey/visibility`;

export const CONTENT_CREATE = `${mainUrl}/library`;
export const CONTENT_EDIT = `${mainUrl}/library`;

// GET - https://4majc3no2f.execute-api.sa-east-1.amazonaws.com/dev/content/{contentType}/{uniqueId}
export const CONTENT_GET = (contentType, uniqueId) => `${mainUrl}/content/${contentType}/${uniqueId}`;

// GET - https://4majc3no2f.execute-api.sa-east-1.amazonaws.com/dev/library/{libraryType}
export const LIBRARY_GET_CONTENT = (type) => `${mainUrl}/library/${type}`;

// GET - https://4majc3no2f.execute-api.sa-east-1.amazonaws.com/dev/journey/enigma/answers/{enigmaId}
export const ENIGMA_GET_ANSWERS = (enigmaId) => `${mainUrl}/journey/enigma/answers/${enigmaId}`;

// POST - https://4majc3no2f.execute-api.sa-east-1.amazonaws.com/dev/journey/enigma/answers
export const ENIGMA_VALIDATE_ANSWER = `${mainUrl}/journey/enigma/answers`;
